// extracted by mini-css-extract-plugin
export var alertBox = "main-module--alert-box--e885f";
export var main = "main-module--main--de708";
export var metamorphosis = "main-module--metamorphosis--26e3b";
export var paddingEqualToHeader = "main-module--padding-equal-to-header--27016";
export var paddingEqualToHeaderOnPhone = "main-module--padding-equal-to-header-on-phone--7fab7";
export var pwaLoader = "main-module--pwaLoader--17208";
export var pwaLoaderOverride = "main-module--pwaLoaderOverride--bc790";
export var topBars = "main-module--top-bars--2bbc7";
export var transparent = "main-module--transparent--5f17d";
export var wrapper = "main-module--wrapper--0c372";